// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  env: "development",
  apiUrl: "https://hidtest.stc.vn:8643",
  facebookAppId: "1101023373682553",
  viewerUrl: "http://localhost:2428/Viewer.aspx",
  firebase: {
    apiKey: "AIzaSyDjIvzpvI0el7j8MgxZcQ-d5o9rTBKZeE4",
    authDomain: "invivolab-d26fe.firebaseapp.com",
    projectId: "invivolab-d26fe",
    storageBucket: "invivolab-d26fe.firebasestorage.app",
    messagingSenderId: "919108602480",
    appId: "1:919108602480:web:1ee0378e30c32d5d4642b5",
    measurementId: "G-6QYQJ2D3M4",
    vapidKey: "BDpk9vLgwbcZ39HLD_xR0SVKXfOgX6zV44dC_6XjlzZfc3xMYuGxO65b9C_3gBLndM1jYYFnqn1P9F-sfjyuP0A"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
